// extracted by mini-css-extract-plugin
module.exports = {"buttonsFooter":"EditPackedBoxes_buttonsFooter___-zHV"};